import styles from './serviceAccountDetailsComponent.scss';
const ServiceAccountDetailsComponent = (props) => {
  let details = props.selectedAccount;
  let contractNumber = details.contractNumber;
  let houseNumber = details.houseNumber;
  let strAddress = (details.streetAddress).toLowerCase();
  let city = (details.city).toLowerCase();
  let state = (details.state);
  let zipCode = (details.zipcode);
  let serviceAddress = houseNumber + " " + (details.streetAddress).toUpperCase() + " " + (details.city).toUpperCase() + " " + state + " " + zipCode;
  //let serviceAddress = details.serviceAddress;
  const serviceAccountDetailsJSX =
    <div className={styles.sceServiceAccInfoOuter}>
      <div className={styles.sceServiceAccInfo}>
        <div className='row'>
          <div className={'col-sm-12 col-xs-12'}>
          <div className={styles.displayFlex}>
            <div className={styles.AccountAddress} title={serviceAddress}>
              {houseNumber}{" "}{strAddress}{","}{" "}{city}{","}{" "}{state}{" "}{zipCode}
              </div>
              <span className={styles.account}>&nbsp;{"- Acct.  "}{contractNumber}</span>
            </div>
          </div>

        </div>
      </div>
    </div>;

  return (
    <div>
      {serviceAccountDetailsJSX}
    </div>
  );

};


export default ServiceAccountDetailsComponent;
